module.exports = __webpack_public_path__ + "static/media/shutter.467a9027.m4a";


//////////////////
// WEBPACK FOOTER
// ./src/components/Webcam/shutter.m4a
// module id = 87
// module chunks = 0